import { Box } from '@mantine/core';
import { ConfigFieldValue, DataInput } from '@/types/automationFields.ts';
import DataInputSelectorUI from '@/pages/Editor/components/SharedFields/DataInputSelector/DataInputSelectorUI.tsx';
import { getInputContractDescription } from '@/pages/Editor/components/SharedFields/DataInputSelector/inputContractStatus.ts';
import useFieldConfigError from '@/hooks/useFieldConfigError.ts';
import { IntegrationDataInputSelectConfigField } from '@/types/integrations.ts';

type props = {
  stepId: string;
  field: IntegrationDataInputSelectConfigField;
  fieldValue?: DataInput | null;
  fieldValueConfig: ConfigFieldValue;
  onChange: (updated_value: any) => void;
};

const DataInputSelectField = ({ stepId, field, fieldValue, fieldValueConfig, onChange }: props) => {
  const error = useFieldConfigError(stepId, fieldValueConfig);
  const contractDescription = getInputContractDescription(field.description, field.input_contract);

  return (
    <Box pos="relative">
      <DataInputSelectorUI
        description={contractDescription ?? undefined}
        placeholder={field.placeholder ?? undefined}
        dataInput={fieldValue || null}
        stepId={stepId}
        updateDataInput={(dataInput: DataInput) => onChange(dataInput)}
        error={error?.message}
        disabled={fieldValueConfig.is_disabled}
        label={field.display_name}
        required={field.required || field.input_contract?.required === true}
        inputContract={field.input_contract}
      />
    </Box>
  );
};

export default DataInputSelectField;
